const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProxmox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 192 192",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M172.133 50.595s-15.355-11.338-25.145-.284c-9.79 11.054-41.378 45.127-41.378 45.127l41.143 44.813s11.078 8.066 24.519-.277c.806-.5-39.947-44.374-39.947-44.374zm-75.775 54.249 48.75 53.547s-11.607 9.527-22.433-.679c-9.806-9.244-26.179-27.13-26.179-27.13l-25.869 26.781s-10.476 9.503-22.88 1.028c-.658-.45 48.611-53.547 48.611-53.547zm-.111-18.807 48.75-53.547s-11.607-9.527-22.433.679c-9.806 9.244-26.18 27.13-26.18 27.13L70.517 33.517s-10.476-9.503-22.88-1.028c-.658.45 48.611 53.547 48.611 53.547zM20.312 50.64s15.355-11.338 25.145-.284c9.79 11.054 41.378 45.128 41.378 45.128l-41.143 44.812s-11.078 8.066-24.519-.276c-.806-.5 39.947-44.375 39.947-44.375z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 57.5,
      paintOrder: "stroke markers fill"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProxmox);
export default __webpack_public_path__ + "static/media/proxmox.8a973de6299c5735e3bb47d14c15d159.svg";
export { ForwardRef as ReactComponent };